import request from '@/utils/request';
export function login(data) {
  // 用户中心的登录
  return request({
    url: "/login/pwd",
    method: 'post',
    data: data
  });
}
// export function login(username, password, code, uuid) {
//     // return request({
//     //     url: 'auth/login',
//     //     method: 'post',
//     //     data: {
//     //         username,
//     //         password,
//     //         code,
//     //         uuid
//     //     }
//     // })
//     // 用户中心的登录
//     return userCenterLoad({
//         url: 'authUser/passwordLogin',
//         method: 'post',
//         data: {
//             username,
//             password,
//         }
//     })
// }

export function getInfo() {
  // 用户中心的用户信息
  return request({
    url: '/user/auth',
    method: 'get'
  });
}
export function getCodeImg() {
  return request({
    url: 'auth/code',
    method: 'get'
  });
}
export function logout() {
  return request({
    url: '/user/logout',
    method: 'get'
  });
}
export function postCode(mobile) {
  return request({
    url: "/authUser/sendMobileCode/".concat(mobile),
    method: 'post'
  });
}